import { render, staticRenderFns } from "./MisOTFechaentrega.vue?vue&type=template&id=0a223e2a&"
import script from "./MisOTFechaentrega.vue?vue&type=script&lang=js&"
export * from "./MisOTFechaentrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports